// The following value for returnKeyType are supported Cross platform
// https://reactnative.dev/docs/textinput#returnkeytype
export enum Native_Return_Keys {
  ENTER = 'enter',
  DONE = 'done',
  NEXT = 'next',
  SEARCH = 'search',
  SEND = 'send',
}
